import "./postal-code-search-row.css";

import { Error } from "@tql/ui-components-react/kendo/labels";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { bookOpen_01 } from "@tql/ui-components-react/untitled/icons";

import type { SearchResult } from "~/shared/components/fields/address-postal-code-search.tsx";
import { AddressPostalCodeSearch } from "~/shared/components/fields/address-postal-code-search.tsx";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";

type PostalCodeSearchRowProps = {
	readonly customerId: number | undefined;
	readonly disabled: boolean;
	readonly onSelectionChange: (selectedItem: SearchResult | null) => void;
	readonly stopType: number;
	readonly value: string;
	readonly addressBookDisabled: boolean;
	readonly onAddressBookClick: () => void;
	readonly showValidationError?: boolean;
	readonly validationMessage?: string;
	readonly onlySearchAddressBook?: boolean;
	readonly placeholder?: string;
	readonly clearOnSelect?: boolean;
	/** Hides the inline Address Book button, e.g. when it's rendered elsewhere (mobile section header). */
	readonly hideAddressBookButton?: boolean;
};

export function PostalCodeSearchRow({
	customerId,
	disabled,
	onSelectionChange,
	stopType,
	value,
	addressBookDisabled,
	onAddressBookClick,
	showValidationError = false,
	validationMessage,
	onlySearchAddressBook = false,
	placeholder = "Postal Code, City, or Saved Address",
	clearOnSelect = false,
	hideAddressBookButton = false,
}: PostalCodeSearchRowProps) {
	const isMobile = useIsMobile();

	return (
		<div className={"postal-code-country-row"}>
			<div className={"postal-code-search"}>
				<AddressPostalCodeSearch
					clearOnSelect={clearOnSelect}
					customerId={customerId}
					disabled={disabled}
					onSelectionChange={onSelectionChange}
					onlySearchAddressBook={onlySearchAddressBook}
					placeholder={placeholder}
					stopType={stopType}
					valid={!showValidationError}
					value={value}
				/>
				{showValidationError ? <Error>{validationMessage}</Error> : null}
			</div>
			{hideAddressBookButton ? null : (
				<div className={"address-book-button"}>
					<Button
						disabled={addressBookDisabled}
						onClick={onAddressBookClick}
						svgIcon={bookOpen_01}
						tabIndex={-1}
						variant={isMobile ? "tertiary" : undefined}
					>
						Address Book
					</Button>
				</div>
			)}
		</div>
	);
}
